export default {"src":"/_next/static/media/90seconds.8d1b748e.svg","height":668,"width":666};